import { getTime} from "date-fns";

export const generateKey = () => {
  const key = (getTime(new Date()) as unknown) as string;

  return key;
};